export enum ResultType {
    None = 0,
    Ok = 1, 
    NotFound = 2,
    BadRequest = 3,
    Conflict = 4,
    Error = 5
  }